
import { Card, Col, Row, Spinner } from "react-bootstrap";
import { StyledCardBody, StyledCardHeader } from "../../../components/dashboard/attentionPoints/styles";
import DashboardChart from "../../../components/dashboard/chart";
import { PageDataModel } from "../hooks/useInsightsData";
import { useTranslation } from 'react-i18next';

interface DimensionChartsGridProps {
    pageData: PageDataModel;
    loadingEpHistoric: boolean;
    loadingEngHistoric: boolean;
    loadingRelHistoric: boolean;
    loadingSigHistoric: boolean;
    loadingReaHistoric: boolean;
    loadingVitHistoric: boolean;
}

interface DimensionChartProps {
    title: string;
    loading: boolean;
    generalData: any[];
    filteredData: any[];
    typeKey: number;
}

const DimensionChart = ({ title, loading, generalData, filteredData, typeKey }: DimensionChartProps) => (
    <Col md='6'>
        <StyledCardBody style={{ background: '#FFF', color: '#3C4043' }}>
            <StyledCardHeader style={{ borderRadius: '.7em .7em 0 0' }}>
                <h5 className='pb-0'>{title}</h5>
            </StyledCardHeader>
            <Card.Body>
                {loading ? (
                    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '300px' }}>
                        <Spinner style={{ color: '#c9c9c9' }} />
                    </div>
                ) : (
                    <DashboardChart 
                        isLargeChart={false} 
                        positionLineResponsive='20%' 
                        positionLine='9%' 
                        lineSize='236px' 
                        height={300} 
                        generalData={generalData} 
                        filteredData={filteredData} 
                        typeKey={typeKey} 
                    />
                )}
            </Card.Body>
        </StyledCardBody>
    </Col>
);

/**
 * Component to display the grid of dimension charts.
 */
const DimensionChartsGrid = ({
    pageData,
    loadingEpHistoric,
    loadingEngHistoric,
    loadingRelHistoric,
    loadingSigHistoric,
    loadingReaHistoric,
    loadingVitHistoric
}: DimensionChartsGridProps) => {
    const { t } = useTranslation('insights');
    const dimensions = [
        { title: t('dimension.positive'), loading: loadingEpHistoric, generalData: pageData.epHistoric, filteredData: pageData.filteredEpHistoric, typeKey: 2 },
        { title: t('dimension.engagement'), loading: loadingEngHistoric, generalData: pageData.engHistoric, filteredData: pageData.filteredEngHistoric, typeKey: 3 },
        { title: t('dimension.relationship'), loading: loadingRelHistoric, generalData: pageData.relHistoric, filteredData: pageData.filteredRelHistoric, typeKey: 4 },
        { title: t('dimension.meaning'), loading: loadingSigHistoric, generalData: pageData.sigHistoric, filteredData: pageData.filteredSigHistoric, typeKey: 5 },
        { title: t('dimension.accomplishment'), loading: loadingReaHistoric, generalData: pageData.reaHistoric, filteredData: pageData.filteredReaHistoric, typeKey: 6 },
        { title: t('dimension.vitality'), loading: loadingVitHistoric, generalData: pageData.vitHistoric, filteredData: pageData.filteredVitHistoric, typeKey: 7 },
    ];

    return (
        <Row className='pb-2 pt-2 '>
            {dimensions.map(dim => (
                <DimensionChart key={dim.title} {...dim} />
            ))}
        </Row>
    );
};

export default DimensionChartsGrid;
